import React, { Component } from 'react';

class StatusProgress extends Component {
  render() {
    let start = 5528;
    let end = 385;
    let progress = start - (this.props.progress / 100) * (start - end);

    return (
      <svg
        className="road-img-progress"
        width="336px"
        height="1554px"
        viewBox="0 0 336 1554"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs></defs>
        <g
          id="road_progress-page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="square"
        >
          <g
            id="road_progress"
            className="road_progress1"
            transform="translate(-282.000000, -196.000000)"
            stroke="#9575cd"
            strokeLinecap="round"
            strokeDasharray="6000"
            strokeDashoffset={progress}
            strokeWidth="15"
          >
            <path
              d="M609.5,203.628522 L609.5,247.5 C609.5,266.829966 593.829966,282.5 574.5,282.5 L332.25,282.5 C308.915969,282.5 290,301.415969 290,324.75 L290,324.75 C290,348.084031 308.915969,367 332.25,367 L566.818998,367 C590.391065,367 609.5,386.108935 609.5,409.681002 L609.5,409.681002 C609.5,433.253068 590.391065,452.362003 566.818998,452.362003 L332.537262,452.362003 C309.044581,452.362003 290,471.406584 290,494.899266 L290,494.899266 C290,518.391947 309.044581,537.436528 332.537262,537.436528 L567.050785,537.436528 C590.494839,537.436528 609.5,556.441689 609.5,579.885743 L609.5,579.885743 C609.5,603.329797 590.494839,622.334958 567.050785,622.334958 L333.160114,622.334958 C309.62759,622.334958 290.550711,641.411837 290.550711,664.94436 L290.550711,664.94436 C290.550711,688.476884 309.62759,707.553763 333.160114,707.553763 L567.053249,707.553763 C590.495942,707.553763 609.5,726.55782 609.5,750.000514 L609.5,750.000514 C609.5,773.443207 590.495942,792.447264 567.053249,792.447264 L333.13073,792.447264 C309.614435,792.447264 290.550711,811.510988 290.550711,835.027283 L290.550711,835.027283 C290.550711,858.543578 309.614435,877.607302 333.13073,877.607302 L567.104433,877.607302 C590.518858,877.607302 609.5,896.588444 609.5,920.002869 L609.5,920.002869 C609.5,943.417294 590.518858,962.398435 567.104433,962.398435 L333.079925,962.398435 C309.591689,962.398435 290.550711,981.439413 290.550711,1004.92765 L290.550711,1004.92765 C290.550711,1028.41589 309.591689,1047.45686 333.079925,1047.45686 L567.016093,1047.45686 C590.479307,1047.45686 609.5,1066.47756 609.5,1089.94077 L609.5,1089.94077 C609.5,1113.40398 590.479307,1132.42468 567.016093,1132.42468 L333.05566,1132.42468 C309.580825,1132.42468 290.550711,1151.45479 290.550711,1174.92963 L290.550711,1174.92963 C290.550711,1198.40446 309.580825,1217.43457 333.05566,1217.43457 L567.086614,1217.43457 C590.51088,1217.43457 609.5,1236.42369 609.5,1259.84796 L609.5,1259.84796 C609.5,1283.27223 590.51088,1302.26135 567.086614,1302.26135 L333.179047,1302.26135 C309.636067,1302.26135 290.550711,1321.3467 290.550711,1344.88968 L290.550711,1344.88968 C290.550711,1368.43266 309.636067,1387.51802 333.179047,1387.51802 L567.010524,1387.51802 C590.476813,1387.51802 609.5,1406.5412 609.5,1430.00749 L609.5,1430.00749 C609.5,1453.47378 590.476813,1472.49697 567.010524,1472.49697 L333.02168,1472.49697 C309.565612,1472.49697 290.550711,1491.51187 290.550711,1514.96794 L290.550711,1514.96794 C290.550711,1538.42401 309.565612,1557.43891 333.02168,1557.43891 L574.594544,1557.43891 C593.887549,1557.43891 609.54223,1573.0513 609.594416,1592.34424 L610,1742.28823"
              id="progress-mega_line-new"
            ></path>
          </g>
        </g>
      </svg>
    );
  }
}

export default StatusProgress;
